(function() {
  "use strict";

  if (window.__boatRampIQMapboxWaterMapLoaded) {
    return;
  }
  window.__boatRampIQMapboxWaterMapLoaded = true;

  var MAPBOX_TOKEN =
    "pk.eyJ1Ijoic2VtaWxvY2F0b3IyMDI1IiwiYSI6ImNtanFteTA2eTMyMzIzaG9sODFzbjM4NWgifQ.ulLE-vR8_Q_iNULAK71dbg";

  var CONFIG = {
    defaultCenter: [-89.70, 34.50],
    defaultZoom: 7,
    searchZoom: 11.8,
    rampMarkerMinZoom: 4,
    rampSourceId: "wm-ramp-source",
    rampCircleLayerId: "wm-ramp-pins",
    rampIconLayerId: "wm-ramp-anchor-icons",
    rampAnchorImageId: "wm-ramp-anchor-image",
    radiusMeters: 30000,
    maxResults: 80,
    requestTimeoutMs: 18000,
    nominatimEndpoint: "https://nominatim.openstreetmap.org/search",
    overpass: [
      "https://overpass-api.de/api/interpreter",
      "https://overpass.kumi.systems/api/interpreter"
    ]
  };


  var CANONICAL_WATERS = [
    {
      id: "canonical-pickwick-lake",
      name: "Pickwick Lake",
      address: "Mississippi · Tennessee · Alabama",
      lng: -88.2529,
      lat: 34.9559
    },
    {
      id: "canonical-sardis-lake",
      name: "Sardis Lake",
      address: "Sardis, Mississippi",
      lng: -89.7987,
      lat: 34.4107
    },
    {
      id: "canonical-arkabutla-lake",
      name: "Arkabutla Lake",
      address: "Coldwater, Mississippi",
      lng: -90.1127,
      lat: 34.7573
    },
    {
      id: "canonical-grenada-lake",
      name: "Grenada Lake",
      address: "Grenada, Mississippi",
      lng: -89.7167,
      lat: 33.8080
    },
    {
      id: "canonical-ross-barnett",
      name: "Ross Barnett Reservoir",
      address: "Jackson metro, Mississippi",
      lng: -89.9868,
      lat: 32.4383
    }
  ];

  var state = {
    map: null,
    mapReady: false,
    programmaticMove: false,
    userMoved: false,
    selectedArea: null,
    centerMarker: null,
    userMarker: null,
    rampMarkers: new Map(),
    results: [],
    selectedRampId: null,
    searchAbort: null,
    rampAbort: null,
    debounceTimer: null,
    loadingHidden: false,
    styleFallbackAttempted: false,
    mapVisualReady: false
  };

  var el = {
    shell: document.getElementById("wm-shell"),
    loading: document.getElementById("wm-loading"),
    loadingCopy: document.getElementById("wm-loading-copy"),
    input: document.getElementById("wm-search-input"),
    searchSubmit: document.getElementById("wm-search-submit"),
    suggestions: document.getElementById("wm-suggestions"),
    back: document.getElementById("wm-back"),
    locationChip: document.getElementById("wm-location-chip"),
    dataChip: document.getElementById("wm-data-chip"),
    searchArea: document.getElementById("wm-search-area"),
    locate: document.getElementById("wm-locate"),
    fit: document.getElementById("wm-fit"),
    pill: document.getElementById("wm-results-pill"),
    count: document.getElementById("wm-count"),
    resultsTitle: document.getElementById("wm-results-title"),
    resultsSubtitle: document.getElementById("wm-results-subtitle"),
    backdrop: document.getElementById("wm-sheet-backdrop"),
    sheet: document.getElementById("wm-sheet"),
    sheetClose: document.getElementById("wm-sheet-close"),
    sheetTitle: document.getElementById("wm-sheet-title"),
    list: document.getElementById("wm-list"),
    toast: document.getElementById("wm-toast")
  };

  function setViewportHeight() {
    var height = window.visualViewport
      ? window.visualViewport.height
      : window.innerHeight;

    document.documentElement.style.setProperty(
      "--wm-height",
      Math.round(height) + "px"
    );

    if (state.map) {
      state.map.resize();
    }
  }

  function startPageMode() {
    document.documentElement.classList.add("wm-map-open");
    document.body.classList.add("wm-map-open");
    setViewportHeight();
  }

  function stopPageMode() {
    document.documentElement.classList.remove("wm-map-open");
    document.body.classList.remove("wm-map-open");
  }

  function hideLoading() {
    if (state.loadingHidden) {
      return;
    }

    state.loadingHidden = true;
    el.loading.classList.add("is-hidden");
  }

  function showToast(message) {
    el.toast.textContent = message;
    el.toast.classList.add("is-visible");
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(function() {
      el.toast.classList.remove("is-visible");
    }, 3000);
  }

  function escapeHTML(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function titleCase(value) {
    return String(value || "")
      .replace(/[_-]+/g, " ")
      .replace(/\b\w/g, function(character) {
        return character.toUpperCase();
      });
  }

  function haversineMiles(lat1, lng1, lat2, lng2) {
    var radius = 3958.7613;
    var toRad = function(value) {
      return value * Math.PI / 180;
    };
    var dLat = toRad(lat2 - lat1);
    var dLng = toRad(lng2 - lng1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);

    return radius * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function openSheet() {
    el.sheet.classList.add("is-open");
    el.backdrop.classList.add("is-visible");
  }

  function closeSheet() {
    el.sheet.classList.remove("is-open");
    el.backdrop.classList.remove("is-visible");
  }

  function closeSuggestions() {
    el.suggestions.classList.remove("is-open");
  }

  function setSearchBusy(busy) {
    el.searchSubmit.disabled = busy;
    el.searchSubmit.textContent = busy ? "Finding…" : "Search";
  }

  function createCenterElement(kind) {
    var div = document.createElement("div");
    div.className =
      kind === "user" ? "wm-user-marker" : "wm-center-marker";
    return div;
  }

  function createRampElement(ramp) {
    var button = document.createElement("button");
    button.type = "button";
    button.className = "wm-ramp-marker";
    button.setAttribute("aria-label", ramp.name);
    button.innerHTML =
      '<span class="wm-ramp-marker-body"></span>' +
      '<span class="wm-ramp-marker-icon">⚓</span>';

    button.addEventListener("click", function() {
      selectRamp(ramp.id, true);
    });

    return button;
  }

  function setCenterMarker(lng, lat) {
    if (state.centerMarker) {
      state.centerMarker.setLngLat([lng, lat]);
      return;
    }

    state.centerMarker = new mapboxgl.Marker({
      element: createCenterElement("center"),
      anchor: "center"
    })
      .setLngLat([lng, lat])
      .addTo(state.map);
  }

  function commitCamera(center, zoom, options) {
    options = options || {};
    state.programmaticMove = true;
    state.userMoved = false;
    el.searchArea.classList.remove("is-visible");

    if (options.bounds) {
      state.map.fitBounds(options.bounds, {
        padding: {
          top: 125,
          right: 28,
          bottom: 105,
          left: 28
        },
        maxZoom: options.maxZoom || 13,
        duration: options.animate === false ? 0 : 550,
        essential: true
      });
    } else {
      state.map.easeTo({
        center: center,
        zoom: zoom,
        duration: options.animate === false ? 0 : 500,
        essential: true
      });
    }

    window.setTimeout(function() {
      state.programmaticMove = false;
      state.userMoved = false;
    }, 650);
  }

  function initMap() {
    if (!window.mapboxgl) {
      el.loadingCopy.textContent = "The map library could not load.";
      return;
    }

    mapboxgl.accessToken = MAPBOX_TOKEN;

    state.map = new mapboxgl.Map({
      container: "wm-map",
      style: "mapbox://styles/mapbox/navigation-night-v1",
      center: CONFIG.defaultCenter,
      zoom: CONFIG.defaultZoom,
      pitch: 0,
      bearing: 0,
      attributionControl: true,
      antialias: true,
      cooperativeGestures: false,
      fadeDuration: 0
    });

    state.map.dragRotate.disable();
    state.map.touchZoomRotate.disableRotation();

    state.map.on("load", function() {
      state.mapReady = true;
      state.map.resize();
      ensureRampLayers();

      state.map.on("click", CONFIG.rampCircleLayerId, function(event) {
        var feature = event.features && event.features[0];

        if (feature && feature.properties && feature.properties.id) {
          selectRamp(String(feature.properties.id), true);
        }
      });

      state.map.on("mouseenter", CONFIG.rampCircleLayerId, function() {
        state.map.getCanvas().style.cursor = "pointer";
      });

      state.map.on("mouseleave", CONFIG.rampCircleLayerId, function() {
        state.map.getCanvas().style.cursor = "";
      });

      resolveInitialState();
    });

    state.map.on("idle", function() {
      if (!state.mapVisualReady) {
        state.mapVisualReady = true;
        hideLoading();
      }
    });

    window.setTimeout(function() {
      if (!state.mapVisualReady && state.map && !state.styleFallbackAttempted) {
        state.styleFallbackAttempted = true;
        el.loadingCopy.textContent = "Loading a compatible map style…";

        try {
          state.map.setStyle("mapbox://styles/mapbox/streets-v12");
        } catch (error) {
          console.warn("Water Map style fallback:", error);
        }
      }
    }, 4500);

    window.setTimeout(function() {
      if (!state.mapVisualReady) {
        hideLoading();
        showToast("The map background could not render. Search and ramp tools are still available.");
      }
    }, 8500);

    state.map.on("dragstart", function(event) {
      if (!state.programmaticMove && event.originalEvent) {
        state.userMoved = true;
      }
    });

    state.map.on("moveend", function() {
      updateRampMarkerVisibility();

      if (state.userMoved && !state.programmaticMove) {
        el.searchArea.classList.add("is-visible");
      }
    });

    state.map.on("zoomend", updateRampMarkerVisibility);

    state.map.on("style.load", function() {
      if (!state.mapReady) {
        return;
      }

      ensureRampLayers();
      syncRampSource();
    });

    state.map.on("error", function(event) {
      var message =
        event && event.error && event.error.message
          ? event.error.message
          : "Unknown map error";

      console.warn("Water Map:", message);

      if (
        !state.styleFallbackAttempted &&
        /style|source|sprite|glyph|webgl/i.test(message)
      ) {
        state.styleFallbackAttempted = true;

        try {
          state.map.setStyle("mapbox://styles/mapbox/streets-v12");
        } catch (error) {
          console.warn("Water Map style fallback:", error);
        }
      }
    });
  }

  function resolveInitialState() {
    var params = new URLSearchParams(window.location.search);
    var lat = Number(params.get("lat"));
    var lng = Number(params.get("lng"));
    var zoom = Number(params.get("zoom"));
    var query = params.get("query") || params.get("q") || "";
    var rampId = params.get("ramp") || "";

    var hasValidIncomingCoordinates =
      Number.isFinite(lat) &&
      Number.isFinite(lng) &&
      !(Math.abs(lat) < 0.0001 && Math.abs(lng) < 0.0001);

    if (hasValidIncomingCoordinates) {
      state.selectedArea = {
        label: query || "Selected water area",
        lat: lat,
        lng: lng
      };

      el.input.value = query;
      el.locationChip.innerHTML =
        "<strong>" + escapeHTML(state.selectedArea.label) + "</strong>";
      setCenterMarker(lng, lat);

      commitCamera(
        [lng, lat],
        Number.isFinite(zoom) ? zoom : CONFIG.searchZoom,
        { animate: false }
      );

      el.loadingCopy.textContent = "Loading nearby mapped ramps.";

      searchRampsNear(lat, lng, state.selectedArea.label, rampId)
        .finally(function() {});

      return;
    }

    if (
      Number.isFinite(lat) &&
      Number.isFinite(lng) &&
      Math.abs(lat) < 0.0001 &&
      Math.abs(lng) < 0.0001
    ) {
      updateURL({
        lat: "",
        lng: "",
        zoom: "",
        ramp: ""
      });
      el.dataChip.textContent = "Invalid saved location cleared";
    }

    if (query) {
      el.input.value = query;
      runSearch(query, true).finally(function() {});
      return;
    }

    commitCamera(CONFIG.defaultCenter, CONFIG.defaultZoom, {
      animate: false
    });
    el.dataChip.textContent = "Search a location to load ramps";
  }

  function mapboxV6SearchEndpoint(query) {
    return (
      "https://api.mapbox.com/search/geocode/v6/forward" +
      "?q=" + encodeURIComponent(query) +
      "&limit=7" +
      "&country=US" +
      "&language=en" +
      "&types=poi,place,locality,district,neighborhood,address" +
      "&access_token=" + encodeURIComponent(MAPBOX_TOKEN)
    );
  }

  function mapboxV5SearchEndpoint(query) {
    return (
      "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
      encodeURIComponent(query) +
      ".json?limit=7&country=us&language=en&autocomplete=true" +
      "&access_token=" + encodeURIComponent(MAPBOX_TOKEN)
    );
  }

  function nominatimSearchEndpoint(query) {
    var url = new URL(CONFIG.nominatimEndpoint);
    url.searchParams.set("q", query);
    url.searchParams.set("format", "jsonv2");
    url.searchParams.set("addressdetails", "1");
    url.searchParams.set("namedetails", "1");
    url.searchParams.set("limit", "7");
    url.searchParams.set("countrycodes", "us");
    return url.toString();
  }

  function normalizeSearchFeature(feature) {
    var coordinates =
      feature &&
      feature.geometry &&
      Array.isArray(feature.geometry.coordinates)
        ? feature.geometry.coordinates
        : null;

    if (!coordinates || coordinates.length < 2) {
      return null;
    }

    var properties = feature.properties || {};
    var context = properties.context || {};
    var lng = Number(coordinates[0]);
    var lat = Number(coordinates[1]);

    if (!Number.isFinite(lng) || !Number.isFinite(lat)) {
      return null;
    }

    var name =
      properties.name_preferred ||
      properties.name ||
      feature.text ||
      context.name ||
      properties.full_address ||
      "Map location";

    var address =
      properties.full_address ||
      properties.place_formatted ||
      feature.place_name ||
      properties.address ||
      context.place && context.place.name ||
      "";

    return {
      id:
        feature.id ||
        properties.mapbox_id ||
        String(lat) + "," + String(lng),
      name: name,
      address: address,
      lng: lng,
      lat: lat
    };
  }


  function normalizeNominatimSearchFeature(item) {
    var lat = Number(item && item.lat);
    var lng = Number(item && item.lon);

    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      return null;
    }

    var named = item.namedetails || {};
    var address = item.address || {};
    var first = String(item.display_name || "").split(",")[0];

    return {
      id: String(item.place_id || lat + "," + lng),
      name:
        named.name ||
        named["name:en"] ||
        address.water ||
        address.city ||
        address.town ||
        address.village ||
        first ||
        "Map location",
      address: item.display_name || "",
      lng: lng,
      lat: lat
    };
  }

  function fetchSearchResults(query, signal) {
    function fetchJSON(url) {
      return fetchWithTimeout(url, {
        signal: signal,
        headers: { "Accept": "application/json" }
      }, CONFIG.requestTimeoutMs).then(function(response) {
        if (!response.ok) {
          throw new Error("Search provider failed.");
        }
        return response.json();
      });
    }

    return fetchJSON(mapboxV6SearchEndpoint(query))
      .then(function(data) {
        return (data.features || [])
          .map(normalizeSearchFeature)
          .filter(Boolean)
          .filter(function(result) {
            return result.name !== "Map location" || result.address;
          });
      })
      .catch(function() {
        return fetchJSON(mapboxV5SearchEndpoint(query))
          .then(function(data) {
            return (data.features || [])
              .map(normalizeSearchFeature)
              .filter(Boolean)
              .filter(function(result) {
                return result.name !== "Map location" || result.address;
              });
          });
      })
      .catch(function() {
        return fetchJSON(nominatimSearchEndpoint(query))
          .then(function(data) {
            return (data || [])
              .map(normalizeNominatimSearchFeature)
              .filter(Boolean);
          });
      });
  }


  function normalizeSearchWords(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .trim()
      .split(/\s+/)
      .filter(Boolean);
  }

  function canonicalSearchMatches(rawQuery) {
    var queryWords = normalizeSearchWords(rawQuery);

    if (!queryWords.length) {
      return [];
    }

    return CANONICAL_WATERS.filter(function(item) {
      var nameWords = normalizeSearchWords(item.name);

      return queryWords.every(function(word) {
        return nameWords.some(function(nameWord) {
          return (
            nameWord.indexOf(word) === 0 ||
            word.indexOf(nameWord) === 0
          );
        });
      });
    });
  }

  function runSearch(rawQuery, autoCommitFirst) {
    var query = String(rawQuery || "").trim();

    if (!query) {
      showToast("Enter a lake, city, marina, or ramp.");
      return Promise.resolve();
    }

    var canonical = canonicalSearchMatches(query);

    if (canonical.length === 1) {
      chooseSearchResult(canonical[0]);
      return Promise.resolve();
    }

    if (state.searchAbort) {
      state.searchAbort.abort();
    }

    state.searchAbort = new AbortController();
    setSearchBusy(true);
    el.dataChip.textContent = "Finding location options…";

    return fetchSearchResults(query, state.searchAbort.signal)
      .then(function(results) {

        if (!results.length) {
          renderSuggestions([]);
          el.dataChip.textContent = "No matching location found";
          return;
        }

        if (autoCommitFirst || results.length === 1) {
          chooseSearchResult(results[0]);
          return;
        }

        renderSuggestions(results);
        el.dataChip.textContent = "Choose the correct location";
      })
      .catch(function(error) {
        if (error && error.name === "AbortError") {
          return;
        }
        el.dataChip.textContent = "Search temporarily unavailable";
        showToast("Search could not be completed.");
      })
      .finally(function() {
        setSearchBusy(false);
      });
  }

  function renderSuggestions(results) {
    el.suggestions.innerHTML = "";

    if (!results.length) {
      el.suggestions.innerHTML =
        '<div style="padding:17px;color:#9db5c1;font-size:11px;">' +
        "No matching locations found. Try adding the state." +
        "</div>";
      el.suggestions.classList.add("is-open");
      return;
    }

    results.forEach(function(result) {
      var button = document.createElement("button");
      button.type = "button";
      button.className = "wm-suggestion";
      button.innerHTML =
        "<strong>" + escapeHTML(result.name) + "</strong>" +
        "<span>" + escapeHTML(result.address || "Location result") + "</span>";

      button.addEventListener("click", function() {
        chooseSearchResult(result);
      });

      el.suggestions.appendChild(button);
    });

    el.suggestions.classList.add("is-open");
  }

  function chooseSearchResult(result) {
    closeSuggestions();

    state.selectedArea = {
      label: result.name,
      lat: result.lat,
      lng: result.lng
    };

    el.input.value = result.name;
    el.locationChip.innerHTML =
      "<strong>" + escapeHTML(result.name) + "</strong>";

    setCenterMarker(result.lng, result.lat);
    commitCamera([result.lng, result.lat], CONFIG.searchZoom);

    updateURL({
      lat: result.lat,
      lng: result.lng,
      zoom: CONFIG.searchZoom,
      query: result.name,
      ramp: ""
    });

    searchRampsNear(result.lat, result.lng, result.name, "");
  }

  function fetchWithTimeout(url, options, timeoutMs) {
    var controller = new AbortController();
    var externalSignal = options && options.signal;
    var timer = window.setTimeout(function() {
      controller.abort();
    }, timeoutMs || CONFIG.requestTimeoutMs);

    if (externalSignal) {
      externalSignal.addEventListener("abort", function() {
        controller.abort();
      }, { once: true });
    }

    return fetch(url, Object.assign({}, options || {}, {
      signal: controller.signal
    })).finally(function() {
      window.clearTimeout(timer);
    });
  }

  function buildOverpassQuery(lat, lng) {
    return (
      "[out:json][timeout:22];" +
      "(" +
        'nwr["leisure"="slipway"](around:' + CONFIG.radiusMeters + "," + lat + "," + lng + ");" +
        'nwr["waterway"="boat_ramp"](around:' + CONFIG.radiusMeters + "," + lat + "," + lng + ");" +
        'nwr["amenity"="boat_ramp"](around:' + CONFIG.radiusMeters + "," + lat + "," + lng + ");" +
      ");" +
      "out center tags;"
    );
  }

  function fetchOverpass(query, signal) {
    var index = 0;
    var lastError = null;

    function tryNext() {
      if (index >= CONFIG.overpass.length) {
        return Promise.reject(lastError || new Error("Ramp data unavailable."));
      }

      var endpoint = CONFIG.overpass[index];
      index += 1;

      return fetchWithTimeout(endpoint, {
        method: "POST",
        signal: signal,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        body: new URLSearchParams({ data: query })
      }, CONFIG.requestTimeoutMs)
        .then(function(response) {
          if (!response.ok) {
            throw new Error("Ramp data request failed.");
          }
          return response.json();
        })
        .catch(function(error) {
          if (error && error.name === "AbortError" && signal && signal.aborted) {
            throw error;
          }
          lastError = error;
          return tryNext();
        });
    }

    return tryNext();
  }

  function normalizeRamps(elements, originLat, originLng) {
    var seen = {};
    var results = [];

    elements.forEach(function(element) {
      var lat = Number(
        element.lat != null ? element.lat : element.center && element.center.lat
      );
      var lng = Number(
        element.lon != null ? element.lon : element.center && element.center.lon
      );

      if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
        return;
      }

      var key = lat.toFixed(6) + "," + lng.toFixed(6);
      if (seen[key]) {
        return;
      }
      seen[key] = true;

      var tags = element.tags || {};
      var name =
        tags.name ||
        tags["name:en"] ||
        tags.operator ||
        "Mapped Boat Ramp";

      var access =
        tags.access === "private"
          ? "Private access"
          : tags.access === "customers"
            ? "Customer access"
            : tags.access === "no"
              ? "Access restricted"
              : "Public map record";

      var details = [
        access,
        tags.surface ? titleCase(tags.surface) + " surface" : "",
        tags.fee === "yes"
          ? "Fee noted"
          : tags.fee === "no"
            ? "No fee noted"
            : ""
      ].filter(Boolean);

      results.push({
        id: String(element.type) + "-" + String(element.id),
        name: name,
        lat: lat,
        lng: lng,
        details: details,
        distanceMiles: haversineMiles(originLat, originLng, lat, lng)
      });
    });

    results.sort(function(a, b) {
      return a.distanceMiles - b.distanceMiles;
    });

    return results.slice(0, CONFIG.maxResults);
  }

  function searchRampsNear(lat, lng, label, selectedRampId) {
    if (state.rampAbort) {
      state.rampAbort.abort();
    }

    state.rampAbort = new AbortController();

    el.searchArea.disabled = true;
    el.locate.disabled = true;
    el.fit.disabled = true;
    el.dataChip.textContent = "Loading mapped ramps…";
    el.resultsTitle.textContent = "Ramps near " + label;
    el.resultsSubtitle.textContent = "Checking public map records";
    el.sheetTitle.textContent = "Ramps near " + label;
    el.count.textContent = "—";

    return fetchOverpass(buildOverpassQuery(lat, lng), state.rampAbort.signal)
      .then(function(data) {
        var ramps = normalizeRamps(data.elements || [], lat, lng);
        commitResults(ramps, label);

        if (ramps.length) {
          el.dataChip.textContent = "Mapped ramp data loaded";
          fitResultsAfterSearch(lat, lng);
          if (selectedRampId) {
            selectRamp(selectedRampId, false);
          }
        } else {
          el.dataChip.textContent = "No mapped ramps found";
          showToast("No mapped ramps were found nearby.");
        }
      })
      .catch(function(error) {
        if (error && error.name === "AbortError") {
          return;
        }

        commitResults([], label);
        el.dataChip.textContent = "Ramp data temporarily unavailable";
        showToast("Ramp data could not be loaded.");
      })
      .finally(function() {
        el.searchArea.disabled = false;
        el.locate.disabled = false;
        el.fit.disabled = false;
      });
  }


  function updateRampMarkerVisibility() {
    if (!state.map || !state.mapReady) {
      return;
    }

    var visible =
      state.map.getZoom() >= CONFIG.rampMarkerMinZoom
        ? "visible"
        : "none";

    [CONFIG.rampCircleLayerId, CONFIG.rampIconLayerId].forEach(function(layerId) {
      if (state.map.getLayer(layerId)) {
        state.map.setLayoutProperty(
          layerId,
          "visibility",
          visible
        );
      }
    });

    if (state.results.length) {
      el.dataChip.textContent =
        visible === "visible"
          ? "Mapped ramp data loaded"
          : state.results.length + " ramps loaded · zoom in to view pins";
    }
  }

  function rampsToGeoJSON() {
    return {
      type: "FeatureCollection",
      features: state.results.map(function(ramp) {
        return {
          type: "Feature",
          id: ramp.id,
          geometry: {
            type: "Point",
            coordinates: [ramp.lng, ramp.lat]
          },
          properties: {
            id: ramp.id,
            name: ramp.name,
            selected: ramp.id === state.selectedRampId ? 1 : 0
          }
        };
      })
    };
  }


  function ensureAnchorImage() {
    if (!state.map || state.map.hasImage(CONFIG.rampAnchorImageId)) {
      return;
    }

    var size = 64;
    var canvas = document.createElement("canvas");
    canvas.width = size;
    canvas.height = size;

    var context = canvas.getContext("2d");

    context.clearRect(0, 0, size, size);
    context.strokeStyle = "#06202b";
    context.fillStyle = "#06202b";
    context.lineWidth = 5;
    context.lineCap = "round";
    context.lineJoin = "round";

    context.beginPath();
    context.arc(32, 14, 7, 0, Math.PI * 2);
    context.stroke();

    context.beginPath();
    context.moveTo(32, 21);
    context.lineTo(32, 46);
    context.stroke();

    context.beginPath();
    context.moveTo(20, 30);
    context.lineTo(44, 30);
    context.stroke();

    context.beginPath();
    context.moveTo(13, 38);
    context.bezierCurveTo(15, 50, 22, 56, 32, 56);
    context.bezierCurveTo(42, 56, 49, 50, 51, 38);
    context.stroke();

    context.beginPath();
    context.moveTo(13, 38);
    context.lineTo(6, 44);
    context.moveTo(51, 38);
    context.lineTo(58, 44);
    context.stroke();

    state.map.addImage(
      CONFIG.rampAnchorImageId,
      context.getImageData(0, 0, size, size),
      { pixelRatio: 2 }
    );
  }

  function ensureRampLayers() {
    if (!state.map || !state.mapReady || !state.map.isStyleLoaded()) {
      return false;
    }

    ensureAnchorImage();

    if (!state.map.getSource(CONFIG.rampSourceId)) {
      state.map.addSource(CONFIG.rampSourceId, {
        type: "geojson",
        data: rampsToGeoJSON()
      });
    }

    if (!state.map.getLayer(CONFIG.rampCircleLayerId)) {
      state.map.addLayer({
        id: CONFIG.rampCircleLayerId,
        type: "circle",
        source: CONFIG.rampSourceId,
        minzoom: CONFIG.rampMarkerMinZoom,
        paint: {
          "circle-radius": [
            "interpolate",
            ["linear"],
            ["zoom"],
            4, 5,
            7, 7,
            10, 10,
            14, 13
          ],
          "circle-color": [
            "case",
            ["==", ["get", "selected"], 1],
            "#a8ec69",
            "#4cd9ee"
          ],
          "circle-stroke-color": "#ffffff",
          "circle-stroke-width": [
            "case",
            ["==", ["get", "selected"], 1],
            4,
            3
          ],
          "circle-opacity": 1
        }
      });
    }

    if (!state.map.getLayer(CONFIG.rampIconLayerId)) {
      state.map.addLayer({
        id: CONFIG.rampIconLayerId,
        type: "symbol",
        source: CONFIG.rampSourceId,
        minzoom: CONFIG.rampMarkerMinZoom,
        layout: {
          "icon-image": CONFIG.rampAnchorImageId,
          "icon-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            4, 0.44,
            7, 0.52,
            10, 0.64,
            14, 0.76
          ],
          "icon-allow-overlap": true,
          "icon-ignore-placement": true,
          "icon-anchor": "center"
        }
      });
    }

    return true;
  }

  function syncRampSource(attempt) {
    attempt = attempt || 0;

    if (!state.map || !state.mapReady) {
      return;
    }

    if (!ensureRampLayers()) {
      if (attempt < 12) {
        window.setTimeout(function() {
          syncRampSource(attempt + 1);
        }, 150);
      }
      return;
    }

    var source = state.map.getSource(CONFIG.rampSourceId);

    if (source) {
      source.setData(rampsToGeoJSON());
    }

    updateRampMarkerVisibility();
  }


  function clearRampMarkers() {
    state.rampMarkers.clear();

    if (
      state.map &&
      state.mapReady &&
      state.map.getSource(CONFIG.rampSourceId)
    ) {
      state.map.getSource(CONFIG.rampSourceId).setData({
        type: "FeatureCollection",
        features: []
      });
    }
  }

  function commitResults(ramps, label) {
    clearRampMarkers();
    state.results = ramps.slice();
    state.selectedRampId = null;

    syncRampSource();

    window.setTimeout(function() {
      syncRampSource();
    }, 250);

    window.setTimeout(function() {
      syncRampSource();
    }, 800);

    el.count.textContent = String(ramps.length);
    el.resultsTitle.textContent = "Ramps near " + label;
    el.sheetTitle.textContent = "Ramps near " + label;
    el.resultsSubtitle.textContent = ramps.length
      ? ramps.length + " mapped launch point" + (ramps.length === 1 ? "" : "s")
      : "No mapped launch points found";

    renderResults();
  }

  function renderResults() {
    if (!state.results.length) {
      el.list.innerHTML =
        '<div class="wm-empty">' +
          "No mapped boat ramps were found in this area. Pan the map and use " +
          "<strong>Search this area</strong>, or search a nearby city or marina." +
        "</div>";
      return;
    }

    el.list.innerHTML = "";

    state.results.forEach(function(ramp) {
      var button = document.createElement("button");
      button.type = "button";
      button.className =
        "wm-result" + (state.selectedRampId === ramp.id ? " is-selected" : "");
      button.setAttribute("data-ramp-id", ramp.id);

      var details = [
        ramp.distanceMiles.toFixed(1) + " mi",
        ramp.details.join(" • ")
      ].filter(Boolean).join(" · ");

      button.innerHTML =
        '<span class="wm-result-icon">⚓</span>' +
        '<span class="wm-result-copy">' +
          "<strong>" + escapeHTML(ramp.name) + "</strong>" +
          "<span>" + escapeHTML(details) + "</span>" +
        "</span>" +
        '<span class="wm-route">→</span>';

      button.addEventListener("click", function(event) {
        if (event.target.closest(".wm-route")) {
          event.stopPropagation();
          routeToRamp(ramp);
          return;
        }
        selectRamp(ramp.id, true);
      });

      el.list.appendChild(button);
    });
  }

  function selectRamp(rampId, centerMap) {
    var ramp = state.results.find(function(item) {
      return item.id === rampId;
    });

    if (!ramp) {
      return;
    }

    state.selectedRampId = rampId;

    syncRampSource();
    renderResults();

    if (centerMap) {
      commitCamera(
        [ramp.lng, ramp.lat],
        Math.max(state.map.getZoom(), 15)
      );
    }

    updateURL({
      lat: ramp.lat,
      lng: ramp.lng,
      zoom: Math.max(state.map.getZoom(), 15),
      query: state.selectedArea ? state.selectedArea.label : "",
      ramp: ramp.id
    });

    openSheet();
  }

  function fitResultsAfterSearch(searchLat, searchLng) {
    if (!state.results.length) {
      commitCamera([searchLng, searchLat], CONFIG.searchZoom);
      return;
    }

    var bounds = new mapboxgl.LngLatBounds();
    bounds.extend([searchLng, searchLat]);

    state.results.forEach(function(ramp) {
      bounds.extend([ramp.lng, ramp.lat]);
    });

    commitCamera(bounds.getCenter().toArray(), CONFIG.searchZoom, {
      bounds: bounds,
      maxZoom: 13
    });
  }

  function fitAllResults() {
    if (!state.results.length) {
      if (state.selectedArea) {
        commitCamera(
          [state.selectedArea.lng, state.selectedArea.lat],
          CONFIG.searchZoom
        );
      } else {
        showToast("Search a location first.");
      }
      return;
    }

    var bounds = new mapboxgl.LngLatBounds();

    state.results.forEach(function(ramp) {
      bounds.extend([ramp.lng, ramp.lat]);
    });

    commitCamera(bounds.getCenter().toArray(), state.map.getZoom(), {
      bounds: bounds,
      maxZoom: 14
    });
  }

  function searchCurrentArea() {
    if (!state.map || !state.mapReady) {
      showToast("The map is still getting ready.");
      return;
    }

    var center = state.map.getCenter();

    if (
      !center ||
      !Number.isFinite(center.lat) ||
      !Number.isFinite(center.lng)
    ) {
      showToast("Boat Ramp IQ could not read this map area.");
      return;
    }

    state.selectedArea = {
      label: "Current map area",
      lat: center.lat,
      lng: center.lng
    };

    setCenterMarker(center.lng, center.lat);
    el.locationChip.innerHTML = "<strong>Current map area</strong>";
    el.searchArea.classList.remove("is-visible");
    state.userMoved = false;
    el.dataChip.textContent = "Searching this map area…";
    showToast("Searching this map area for mapped ramps…");

    updateURL({
      lat: center.lat,
      lng: center.lng,
      zoom: state.map.getZoom(),
      query: "Current map area",
      ramp: ""
    });

    searchRampsNear(center.lat, center.lng, "current map area", "")
      .finally(function() {
        state.userMoved = false;
      });
  }


  function isUsableLocation(position) {
    if (!position || !position.coords) {
      return false;
    }

    var lat = Number(position.coords.latitude);
    var lng = Number(position.coords.longitude);
    var accuracy = Number(position.coords.accuracy);

    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      return false;
    }

    if (Math.abs(lat) < 0.0001 && Math.abs(lng) < 0.0001) {
      return false;
    }

    if (Number.isFinite(accuracy) && accuracy > 25000) {
      return false;
    }

    return true;
  }

  function locateUser() {
    if (!navigator.geolocation) {
      el.dataChip.textContent = "Location unavailable";
      showToast("Location is not available on this device.");
      return;
    }

    el.dataChip.textContent = "Finding your location…";
    showToast("Requesting your GPS location…");

    var finished = false;
    var watchdog = window.setTimeout(function() {
      if (finished) {
        return;
      }

      finished = true;
      el.dataChip.textContent = "Location request timed out";
      showToast("GPS did not respond. Check location permission, or search a lake or city.");
    }, 10000);

    navigator.geolocation.getCurrentPosition(
      function(position) {
        if (finished) {
          return;
        }

        finished = true;
        window.clearTimeout(watchdog);

        if (!isUsableLocation(position)) {
          el.dataChip.textContent = "Location unavailable";
          showToast("Your device returned an invalid GPS location. Search a lake or city instead.");
          return;
        }

        var lat = position.coords.latitude;
        var lng = position.coords.longitude;

        if (state.userMarker) {
          state.userMarker.setLngLat([lng, lat]);
        } else {
          state.userMarker = new mapboxgl.Marker({
            element: createCenterElement("user"),
            anchor: "center"
          })
            .setLngLat([lng, lat])
            .addTo(state.map);
        }

        state.selectedArea = {
          label: "Your location",
          lat: lat,
          lng: lng
        };

        setCenterMarker(lng, lat);
        el.locationChip.innerHTML = "<strong>Your location</strong>";
        el.dataChip.textContent = "GPS location found";
        commitCamera([lng, lat], 12);

        updateURL({
          lat: lat,
          lng: lng,
          zoom: 12,
          query: "Your location",
          ramp: ""
        });

        showToast("Location found. Searching nearby mapped ramps…");
        searchRampsNear(lat, lng, "your location", "");
      },
      function(error) {
        if (finished) {
          return;
        }

        finished = true;
        window.clearTimeout(watchdog);
        el.dataChip.textContent = "Location unavailable";

        showToast(
          error && error.code === 1
            ? "Location permission was not granted."
            : error && error.code === 3
              ? "GPS timed out. Try again or search a location."
              : "Your location could not be determined."
        );
      },
      {
        enableHighAccuracy: true,
        timeout: 9000,
        maximumAge: 15000
      }
    );
  }

  function routeToRamp(ramp) {
    window.location.href =
      "https://maps.apple.com/?daddr=" +
      encodeURIComponent(ramp.lat + "," + ramp.lng) +
      "&q=" +
      encodeURIComponent(ramp.name) +
      "&dirflg=d";
  }

  function updateURL(values) {
    try {
      var url = new URL(window.location.href);

      Object.keys(values).forEach(function(key) {
        var value = values[key];
        if (value === "" || value == null) {
          url.searchParams.delete(key);
        } else {
          url.searchParams.set(key, String(value));
        }
      });

      window.history.replaceState({}, "", url);
    } catch (error) {
      return;
    }
  }

  function bindEvents() {
    el.searchSubmit.addEventListener("click", function() {
      runSearch(el.input.value, false);
    });

    el.input.addEventListener("keydown", function(event) {
      if (event.key === "Enter") {
        event.preventDefault();
        runSearch(el.input.value, false);
      } else if (event.key === "Escape") {
        closeSuggestions();
      }
    });

    el.input.addEventListener("input", function() {
      window.clearTimeout(state.debounceTimer);
      var query = el.input.value.trim();

      if (query.length < 3) {
        closeSuggestions();
        return;
      }

      state.debounceTimer = window.setTimeout(function() {
        runSearch(query, false);
      }, 430);
    });

    el.back.addEventListener("click", function() {
      stopPageMode();
      window.location.href = "/pages/find-a-ramp";
    });

    el.searchArea.addEventListener("click", searchCurrentArea);
    el.locate.addEventListener("click", locateUser);
    el.fit.addEventListener("click", fitAllResults);
    el.pill.addEventListener("click", openSheet);
    el.sheetClose.addEventListener("click", closeSheet);
    el.backdrop.addEventListener("click", closeSheet);

    document.addEventListener("click", function(event) {
      if (!event.target.closest(".wm-search-wrap")) {
        closeSuggestions();
      }
    });

    window.addEventListener("resize", setViewportHeight);
    window.addEventListener("orientationchange", function() {
      window.setTimeout(setViewportHeight, 140);
    });

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", setViewportHeight);
    }

    window.addEventListener("pagehide", stopPageMode);
  }

  startPageMode();
  bindEvents();
  initMap();

  window.setTimeout(function() {
    if (!state.loadingHidden) {
      hideLoading();
      showToast("Water Map is taking longer than expected.");
    }
  }, 7000);
})();
